// Prints the page when a button targets this element with command="--print".
class PrintTarget extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.addEventListener(
      'command',
      (event) => {
        if (event.command === '--print') window.print();
      },
      { signal: this.controller.signal }
    );
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('s-print-target')) customElements.define('s-print-target', PrintTarget);
